
import React from "react";
import ProductItem from "components/product/item";
import { ReactComponent as CartIcon } from "svgs/huge-shoping-cart.svg";
import { useSettings } from "hooks/useStore";
import Link from "components/link";

const EmptyCart = ({ upsellProducts }) => {
	const { toggleCart } = useSettings(["toggleCart"]);

	return (
		<div className="w-full empty-cart px-5" >
			<div className="flex-center flex-col w-full py-14 md:py-20 gap-2.5">
				<CartIcon />
				<div className="text-center">
					<p>Looks like your cart is empty.</p>
					<p> Let`s get you started</p>
				</div>
				<Link
					to="/collections/all-modern-light-fixtures"
					onClick={toggleCart}
					className="py-5 md:px-10 btn-secondary"
				>
					Shop Best Sellers
				</Link>
			</div>
			{upsellProducts.length > 0 ?
				<div className="flex flex-col gap-5">
					<h4>Explore Our Best Sellers</h4>
					<div className="flex flex-wrap gap-4">
						{upsellProducts.map((product, index) => (
							<div key={index} className="w-2/5 flex-auto md:flex-1">
								<ProductItem
									index={index + 1}
									product={product}
									showModal={false}
									priceClass="text-xs ml-2 text-end md:text-sm"
									callback={toggleCart}
									showViewDetails={false} />
							</div>
						))}
					</div>
				</div>
				: null
			}
		</div >
	);
};

export default EmptyCart;